import { render } from "./FileSystem.vue?vue&type=template&id=a835d844"
import script from "./FileSystem.vue?vue&type=script&lang=js"
export * from "./FileSystem.vue?vue&type=script&lang=js"

import "./FileSystem.vue?vue&type=style&index=0&id=a835d844&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTree});
